import { Injectable } from '@angular/core';

@Injectable()
export class KuiCardService {
  getAligmentClass(className: string = 'left') {
    return `text-${className}`;
  }
}
